<form [formGroup]="form" class="dialog-container">
    <div class="dialog-header">
        <h6>Select Columns to export</h6>
        <p *ngIf="isPdfDisabled" class="pdf-warning">Too many columns selected. Please reduce column selection for PDF
            export.</p>
        <button mat-icon-button class="close-icon" (click)="onClose()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div formArrayName="columns" class="display-section">
        <div class="select-all section" style="grid-column: span 2;">
            <mat-checkbox [checked]="allSelected()" (change)="toggleAll($event)">
                <span style="font-weight: bold;">Select All</span>
            </mat-checkbox>
        </div>

        <div class="select-all section" style="grid-column: span 2;">
            <mat-checkbox [checked]="isApplyCss()" (change)="toggleApplyCss($event)">
                <span style="font-weight: bold;">Highlight Over Due</span>
            </mat-checkbox>
        </div>

        <div *ngFor="let column of columnsToDisplay; let i = index">
            <mat-checkbox [formControlName]="i">
                {{ column.label }}
            </mat-checkbox>
        </div>
    </div>

    <!-- Buttons aligned bottom right -->
    <div class="button-section">
        <button type="button" class="button" (click)="exportData('pdf')" [disabled]="isPdfDisabled">PDF</button>
        <button type="button" class="button" (click)="exportData('excel')">Excel</button>
    </div>

</form>